import {
    GET_STYLE_REQUEST,
    GET_STYLE_SUCCESS,
    GET_STYLE_ERROR,

} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_STYLE_REQUEST:
            return {
                loading: true,
            };
        case GET_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_STYLE_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}